import { OVERLAY_CLASSNAME } from '@app/constants';

export const CUSTOM_DROPDOWN_EVENT = 'dropdown-change';

export const SELECTED_VALUE_CLASSNAME = '.dropdown-selected-value';
const DROPDOWN_CLASSNAME = '.dropdown';
const DROPDOWN_TOGGLE_CLASSNAME = '.dropdown-toggle';
const DROPDOWN_ITEM_CLASSNAME = '.dropdown-item';

const triggerCustomEvent = (element: HTMLElement, value: unknown) => {
  element.dispatchEvent(
    new CustomEvent(CUSTOM_DROPDOWN_EVENT, {
      detail: value,
    })
  );
};

const initDropdownOverlay = (dropdownEl: HTMLElement) => {
  const dropdownOverlayEl = dropdownEl.querySelector(OVERLAY_CLASSNAME);

  if (!dropdownOverlayEl) {
    return;
  }

  dropdownOverlayEl.addEventListener('click', (e) => {
    e.stopPropagation();
    dropdownEl.classList.remove('active');
  });
};

export const initDropdownToggle = (dropdownEl: HTMLElement) => {
  const dropdownToggleEl = dropdownEl.querySelector(DROPDOWN_TOGGLE_CLASSNAME);

  if (!dropdownToggleEl) {
    return;
  }

  dropdownToggleEl.addEventListener('click', () => {
    dropdownEl.classList.toggle('active');
  });

  dropdownToggleEl.setAttribute('listener', 'true');
  dropdownToggleEl.setAttribute(
    'aria-expanded',
    dropdownToggleEl.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
  );
};

const initDropdownListItem = (dropdownEl: HTMLElement) => {
  const selectAndCloseDropdown = (
    dropdownEl: HTMLElement,
    listItemEl: HTMLElement
  ) => {
    const selectedValueEl = dropdownEl.querySelector(
      SELECTED_VALUE_CLASSNAME
    ) as HTMLSpanElement;

    if (!selectedValueEl) {
      return;
    }

    const {
      dataset: { domainName = '', domainValue = '', redirectUri = '' },
    } = listItemEl;
    const {
      dataset: { isStatic },
    } = dropdownEl;

    if (!isStatic) {
      selectedValueEl.textContent = domainName;
      triggerCustomEvent(selectedValueEl, {
        domainName,
        domainValue,
        redirectUri,
      });
    }

    dropdownEl.classList.remove('active');
  };

  const itemsListEls = dropdownEl.querySelectorAll(
    DROPDOWN_ITEM_CLASSNAME
  ) as NodeListOf<HTMLElement>;

  itemsListEls.forEach((listItemEl) => {
    const handler = (e: Event) => {
      const { clientX, clientY } = e as MouseEvent;
      const { key } = e as KeyboardEvent;

      if (e.type === 'click' && clientX !== 0 && clientY !== 0) {
        e.stopPropagation();
        selectAndCloseDropdown(dropdownEl, listItemEl);
      }

      if (key === 'Enter') {
        selectAndCloseDropdown(dropdownEl, listItemEl);
      }
    };

    listItemEl.addEventListener('click', handler);
    listItemEl.addEventListener('keyup', handler);
    document.addEventListener('keyup', ({ key }) => {
      if (key === 'Escape') {
        dropdownEl.classList.remove('active');
      }
    });
  });
};

export const initDropdown = () => {
  const dropdownEls = document.querySelectorAll(
    DROPDOWN_CLASSNAME
  ) as NodeListOf<HTMLElement>;

  dropdownEls.forEach((dropdownEl) => {
    initDropdownOverlay(dropdownEl);

    if (dropdownEl.getAttribute('listener') !== 'true') {
      initDropdownToggle(dropdownEl);
    }

    initDropdownListItem(dropdownEl);
  });
};
